import { Outlet, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import {
    AppBar,
    CssBaseline, Divider,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import {drawerWidth, Main} from "../components/Main";
import PetIcon from "@mui/icons-material/Pets";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import {Theme} from "../components/Theme";
import React, {useEffect, useState, useContext} from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery, useTheme } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { UserContext } from '../contexts/UserContext'; // Import the UserContext

export default function DashboardLayout() {
    const theme = useTheme(); // Access the theme
    const isMdScreen = useMediaQuery(theme.breakpoints.down('md')); // Pass the theme explicitly
    const [isDrawerOpen, setIsDrawerOpen] = useState(!isMdScreen);
    const location = useLocation();
    const { user, logout } = useContext(UserContext); // Get both user and logout method
    useEffect(() => {
        setIsDrawerOpen(!isMdScreen);
    }, [isMdScreen]);
    return (
    <Theme>
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1
            , boxShadow: '0 0 5px rgba(0,0,0,0.5)'}} >
                <Toolbar>
                    <IconButton
                        color="primary"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant="h5" noWrap component="div" sx={{ ml: 2 }}>
                        Mascotix
                    </Typography>
                    <img src={process.env.PUBLIC_URL + '/Logo192.png'} alt="Mascotix Logo" style={{ height: '50px', marginLeft: "10px" }} />
                </Toolbar>
            </AppBar>
            <Drawer
                variant={isMdScreen ? "temporary" : "persistent" }
                anchor="left"
                open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {width: drawerWidth, boxSizing: 'border-box', boxShadow: '0 0 3px rgba(0,0,0,0.2)'},
                }}
            >
                <Toolbar/>
                <Box sx={{overflow: 'auto'}} onClick={e => {
                    if (isMdScreen) {
                        let node = e.target;
                        while (node && node !== e.currentTarget) {
                            if (node.tagName && node.tagName.toLowerCase() === 'a') {
                                setIsDrawerOpen(false);
                                break;
                            }
                            node = node.parentNode;
                        }
                    }
                }}>
                    <List>
                        <ListItemButton
                            component={Link}
                            to={"/visits"}
                            selected={location.pathname.startsWith("/visits")}
                        >
                            <ListItemIcon>
                                <PetIcon />
                            </ListItemIcon>
                            <ListItemText>Visits</ListItemText>
                        </ListItemButton>
                        <ListItemButton
                            component={Link}
                            to={"/clients"}
                            selected={location.pathname.startsWith("/clients")}
                        >
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                            <ListItemText>Clientes</ListItemText>
                        </ListItemButton>
                        <ListItemButton
                            component={Link}
                            to={"/clinic"}
                            selected={location.pathname.startsWith("/clinic")}
                        >
                            <ListItemIcon>
                                <SettingsIcon />
                            </ListItemIcon>
                            <ListItemText>Clinica</ListItemText>
                        </ListItemButton>
                        <Divider/>
                        <ListItemButton
                            component={Link}
                            to={"/account/manage"}
                            selected={location.pathname.startsWith("/account/manage")}
                        >
                            <ListItemIcon>
                                <AccountCircleIcon />
                            </ListItemIcon>
                            <ListItemText>{user?.email || "Account"}</ListItemText>
                        </ListItemButton>                        
                        <ListItemButton
                            component={Link}
                            color="info"
                            onClick={e => { logout(); }}
                        >
                            <ListItemIcon>
                                <LogoutIcon color="info" />
                            </ListItemIcon>
                            <ListItemText>Salir</ListItemText>
                        </ListItemButton>
                    </List>
                    
                </Box>
            </Drawer>
            <Main open={isDrawerOpen} isMdScreen={isMdScreen}>
                <Outlet/>
            </Main>
        </Box>
    </Theme>);
}

